export default __webpack_public_path__ + "static/media/4 in 1 - inactive.ea3e994f.svg";